(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DecapCms", [], factory);
	else if(typeof exports === 'object')
		exports["DecapCms"] = factory();
	else
		root["DecapCms"] = factory();
})(window, () => {
return 